import { jsxs, jsx } from 'react/jsx-runtime';
import React__default from 'react';
import classNames from '../../../node_modules/.pnpm/classnames@2.5.1/node_modules/classnames/index.js';
import { ReactComponent as ForwardRef } from '../../assets/icons/CloseIcon16.svg.js';
import style from './TextField.module.css.js';

const TextField = React__default.forwardRef(({ error, errorMessage, clearable = false, onClear, ...attrs }, ref) => {
    return (jsxs("div", { className: classNames(style.wrapper, attrs.className), children: [jsxs("div", { className: classNames(style.inputWrapper, (error || errorMessage) && style.error), children: [jsx("input", { type: "text", ...attrs, ref: ref, className: classNames(style.textField, (error || errorMessage) && style.error, clearable && style.clearableTextField) }), clearable && (jsx(ForwardRef, { className: classNames(style.closeIcon), onClick: () => onClear && onClear() }))] }), errorMessage && jsx("span", { className: style.errorMessage, children: errorMessage })] }));
});
TextField.displayName = "TextField";

export { TextField };
//# sourceMappingURL=TextField.js.map
